define.alias("shared/components/shared/pre-boarding/auto-trial-start/index", "calendar/components/shared/pre-boarding/auto-trial-start/index");